var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attribute-checkbox"},[_c('el-checkbox',{attrs:{"value":_vm.flag == 1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }